howspace.template = {
    /**
     * Get a template from the DOM and replace the variables with the given object.
     * @param template
     * @param obj
     * @returns {ChildNode|null}
     */
    getHtml: (template, obj = {}) => {
        if (template instanceof jQuery) {
            template = template[0];
        }

        if (!template) {
            return null;
        }

        // Template variable replace engine with DOMPurifier sanitation included.
        // Can handle ${variable_name} and ${nested.variable.name} objects.
        let html = template.innerHTML.trim();
        const matches = html.match(/\${[^}]+}/gim);
        if (matches !== null) {
            matches.forEach(match => {
                const key = match.replace('${', '').replace('}', '');
                let replacement = '';
                if (key.indexOf('.') < 0) {
                    if (obj.hasOwnProperty(key)) {
                        // Sanitize object value with DOMPurify.
                        replacement = DOMPurify.sanitize(obj[key]);
                    }
                } else {
                    // Handle nested objects.
                    let nestedObj = obj;
                    const keys = key.split('.');
                    keys.forEach(nestedKey => {
                        if (nestedObj?.hasOwnProperty(nestedKey)) {
                            nestedObj = nestedObj[nestedKey];
                        } else {
                            nestedObj = null;
                        }
                    });
                    if (nestedObj !== null) {
                        replacement = DOMPurify.sanitize(nestedObj);
                    }
                }
                html = html.replace(match, replacement);
            });
        }

        return html;
    },
    getElement : (template, obj = {}) => {
        const element = document.createElement('div');
        element.innerHTML = howspace.template.getHtml(template, obj);
        return element.firstChild;
    }
};
